import { css } from 'linaria';

export const storageAdditionalSlide = css`
  && {
    width: calc((100% - 24px * 5) / 6);
    height: 240px;
    margin-right: 24px;

    @media (--only-desktop) {
      width: calc((100% - 24px * 4) / 5);
    }

    @media (--to-desktop) {
      width: 176px;
      margin-right: 16px;
    }
  }
`;
